import { render } from "./InitialsAvatar.vue?vue&type=template&id=edfc89e2&scoped=true"
import script from "./InitialsAvatar.vue?vue&type=script&lang=js"
export * from "./InitialsAvatar.vue?vue&type=script&lang=js"

import "./InitialsAvatar.vue?vue&type=style&index=0&id=edfc89e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfc89e2"]])

export default __exports__